import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThinFilmEvaporator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 120,
	viewBox: "0 0 80.0 120.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 10.0 L 80.0 10.0 L 80.0 80.0 L 40.0 120.0 L 0.0 80.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 25.0 30.0 L 25.0 95.0 M 55.0 30.0 L 55.0 95.0 M 25.0 40.0 L 55.0 40.0 M 25.0 85.0 L 55.0 85.0 M 40.0 0.0 L 40.0 40.0 M 0.0 30.0 L 15.0 30.0 L 15.0 95.0 M 80.0 30.0 L 65.0 30.0 L 65.0 95.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgThinFilmEvaporator;
